import React, { FC } from 'react';
import { LineOfBusiness } from '../../interfaces/LineOfBusiness';
import { StyledContactInformation, StyledSection } from './Content.styles';

export interface ContentProps {
  lineOfBusiness: LineOfBusiness;
}

const Content: FC<ContentProps> = ({ lineOfBusiness }) => (
  <StyledSection>
    {lineOfBusiness.contacts.map((c) => (
      <StyledContactInformation key={c.serviceCenter} contact={c} />
    ))}
  </StyledSection>
);

export default Content;
